import { useState } from 'react';

/**
 * Ảnh vuông nhỏ của sản phẩm, đặt đầu mỗi dòng kết quả tìm ở CẢ BA màn.
 *
 * Có từ 14/09 — lật quyết định "không có ảnh" của 28/08. Lý do mới: khách muốn
 * ĐỐI CHIẾU thứ trên màn hình với thứ trên tay, và ảnh + mã hãng + mã vạch là ba
 * thứ khách nhìn được. Ảnh theo DÒNG sản phẩm (233 mặt hàng dùng chung 37 ảnh),
 * nên nó trả lời "đúng dòng son này chưa", không trả lời "đúng màu này chưa" —
 * màu vẫn phải đọc tên.
 *
 * 🔴 Không bao giờ để trống chỗ. Sản phẩm chưa có ảnh, hoặc ảnh hỏng trên máy
 *    chủ, thì hiện ô xám lõm cùng cỡ — danh sách không nhảy dòng theo việc dòng
 *    nào có ảnh dòng nào không. Lỗi tải ảnh KHÔNG được làm màn tư vấn kêu lỗi:
 *    ảnh là phụ, bán hàng là chính.
 *
 * Ảnh phục vụ ở `/media/...` thẳng từ nginx, 512×512 JPG ~20 KB. `loading="lazy"`
 * vì màn tư vấn chạy trên điện thoại và một lần tìm có thể ra 50 dòng.
 */
export function AnhSanPham({ anh, ten, co = 52 }: { anh: string | null; ten: string; co?: number }) {
  const [hong, datHong] = useState(false);
  const khung: React.CSSProperties = {
    width: co,
    height: co,
    flexShrink: 0,
    borderRadius: 12,
    overflow: 'hidden',
    background: 'var(--nen-3)',
    boxShadow: 'var(--lom-nho)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };
  if (!anh || hong) {
    return (
      <div style={khung} aria-hidden="true" data-anh="trong">
        <span style={{ fontSize: co * 0.36, color: 'var(--chu-3)', opacity: 0.7 }}>▫</span>
      </div>
    );
  }
  return (
    <div style={khung}>
      <img
        src={anh}
        alt={ten}
        loading="lazy"
        decoding="async"
        onError={() => datHong(true)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </div>
  );
}

/**
 * Dòng mã để khách đối chiếu: `mã hãng · mã vạch`. Trống cả hai thì không vẽ gì —
 * không hiện "—" hay "chưa có mã", vì đó là chữ thừa trên màn hình chật.
 */
export function MaDoiChieu({ sapcode, barcode }: { sapcode: string | null; barcode: string | null }) {
  if (!sapcode && !barcode) return null;
  return (
    <div
      className="ma-doi-chieu"
      style={{
        fontSize: 11.5,
        color: 'var(--chu-3)',
        marginTop: 2,
        fontVariantNumeric: 'tabular-nums',
        letterSpacing: 0.2,
      }}
    >
      {sapcode}
      {sapcode && barcode && ' · '}
      {barcode}
    </div>
  );
}
